import * as React from "react";
import { useEffect, useState } from "react";
import useLocalStorage from "./useLocalStorage";

const themeContext = React.createContext({
  theme: "system",
  setTheme: (_) => {},
  isDark: false,
});

function useTheme() {
  const [theme, setTheme] = useLocalStorage("theme", "system");
  const [systemPrefersDark, setSystemPrefersDark] = useState(false);

  useEffect(() => {
    // Detect system preference
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setSystemPrefersDark(mediaQuery.matches);

    // Listen for system preference changes
    const handler = (e) => setSystemPrefersDark(e.matches);
    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  // Compute the actual theme to use
  const isDark = theme === "dark" || (theme === "system" && systemPrefersDark);

  return {
    theme,
    setTheme,
    isDark,
  };
}

export function ThemeProvider({ children }) {
  return (
    <themeContext.Provider value={useTheme()}>{children}</themeContext.Provider>
  );
}

export default function ThemeConsumer() {
  return React.useContext(themeContext);
}
